import React from 'react';
import { cn } from '@/utils';

interface SkeletonProps extends React.HTMLAttributes<HTMLDivElement> {}

export function SkeletonBlock({ className, ...props }: SkeletonProps) {
  return <div className={cn('animate-pulse rounded-md bg-light-gray', className)} {...props} />;
}
